import React from "react";
import { Masthead, Heading } from "@xo-union/tk-ui-masthead";
import { compose } from "@xo-union/react-css-modules";
import styles from "./styles.css";
var HeroSection = function HeroSection(_ref) {
  var headline = _ref.headline,
    subtitle = _ref.subtitle,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(Masthead, {
    classes: compose({
      'wrapper': styles['wrapper']
    }),
    size: size,
    heading: /*#__PURE__*/React.createElement(Heading, {
      className: styles.heading
    }, headline),
    copy: subtitle
  });
};
export default HeroSection;